export default "/images/f43a728407ce8b07f9510f56ca8a57aa.avif";